<template>
  <v-simple-table v-if="linhas.length" light>
    <thead>
    <tr class="blue-grey lighten-2" style="height: 50px;">
      <th class="white--text text-subtitle-2">Vendedor</th>
      <th class="white--text text-center text-subtitle-2">Classificação</th>
      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">{{ labelMeta }}</th>
      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">{{ labelVenda }}</th>
      <th class="white--text text-subtitle-2">
        <div class="d-flex align-center justify-center">
          <v-tooltip color="blue-grey" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  icon x-small class="mr-1"
                  v-bind="attrs" v-on="on"
                  @click="$emit('update:mostrarValoresFinanceiros', !mostrarValoresFinanceiros)"
              >
                <v-icon x-small color="white">{{ mostrarValoresFinanceiros ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </v-btn>
            </template>
            <span>{{ mostrarValoresFinanceiros ? 'Ocultar' : 'Exibir' }} meta/venda/margem</span>
          </v-tooltip>
          <span v-if="!acumulado" class="text-no-wrap">{{ labelAtingimento }}</span>
          <span v-else>Atingimento<br>Acumulado</span>
        </div>
      </th>
      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">{{ labelMargem }}</th>
      <th class="white--text text-center text-subtitle-2">Cupons Regra 1</th>
      <th class="white--text text-center text-subtitle-2">Cupons Extras</th>
      <th class="white--text text-center text-subtitle-2">Total Cupons</th>
    </tr>
    </thead>
    <tbody class="font-size-table">
    <tr v-for="item in linhas" :key="item.idvendedor" class="font-weight-bold">
      <td style="height: 23px !important; width:200px; max-width: 200px !important;" class="text-truncate" :title="item.vendedor">
        <v-tooltip v-if="item.admitido_tardiamente === 'T'" color="blue-grey" bottom max-width="280">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="18" color="amber darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
          </template>
          <span class="white--text">
            Admitido após 01/10/2026: não concorre ao sorteio do prêmio OURO. Só concorre aos demais sorteios
            (PRATA/BRONZE) se superar R$ 130.000,00 (ou a meta do mês, se for maior) em todos os meses participados.
          </span>
        </v-tooltip>
        {{ item.vendedor }}
      </td>
      <td style="height: 23px !important;" class="text-center">
        <v-chip x-small :color="classificacaoCor(item.classificacao)" dark class="font-weight-bold">{{ item.classificacao }}</v-chip>
      </td>
      <td v-if="mostrarValoresFinanceiros" style="height: 23px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.meta) }}</td>
      <td v-if="mostrarValoresFinanceiros" style="height: 23px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.venda) }}</td>
      <td style="height: 23px !important;" class="text-center">{{ formatarPercentual(item.peratingimento) }}</td>
      <td v-if="mostrarValoresFinanceiros" style="height: 23px !important;" class="text-center">{{ formatarPercentual(item.margem) }}</td>
      <td style="height: 23px !important;" class="text-center">{{ item.cupons_regra1 }}</td>
      <td style="height: 23px !important;" class="text-center">
        <v-tooltip v-if="cuponsExtras(item) > 0" color="blue-grey" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="cupons-extras-com-detalhe">{{ cuponsExtras(item) }}</span>
          </template>
          <div class="white--text py-1">
            <div v-for="(bloco, idxBloco) in cuponsExtrasBlocos(item)" :key="idxBloco">{{ bloco }}</div>
          </div>
        </v-tooltip>
        <span v-else>0</span>
      </td>
      <td style="height: 23px !important;" class="text-center"><strong>{{ item.total_cupons }}</strong></td>
    </tr>
    </tbody>
    <tfoot>
    <tr class="blue-grey lighten-2 white--text font-weight-bold" style="height: 40px;">
      <td :colspan="mostrarValoresFinanceiros ? 6 : 3" class="text-uppercase">Total</td>
      <td class="text-center">{{ totais.cuponsRegra1 }}</td>
      <td class="text-center">{{ totais.cuponsExtras }}</td>
      <td class="text-center">{{ totais.totalCupons }}</td>
    </tr>
    </tfoot>
  </v-simple-table>
  <div v-else class="text-center py-6 grey--text text--darken-1">Nenhum vendedor pontuou ainda neste período.</div>
</template>

<script>
// Tabela plana (sem agrupar/expandir) da Campanha de Vendas na visão gerente — mesmo visual/estrutura do
// card "Educa Comercial Ivaiporã" (lista simples: vendedor, colunas, rodapé com total), só que sem a coluna
// RK (não é um ranking — todo vendedor da filial entra, não só os melhores colocados) e com as colunas da
// campanha de venda e margem. Meta/Venda/Margem (R$) vêm ocultas por padrão — diferente da
// visão de diretoria (CampanhaVendaMargem.vue), que já abre com mostrarValoresFinanceiros = true — e só
// aparecem com o botão de olho no cabeçalho "% Atingimento" (mesmo padrão visual da diretoria). Reaproveitada
// tanto pelas abas de mês quanto pela aba "Acumulado Geral" do card da campanha na visão gerente
// (CampanhaVendaMargemGerente.vue) — cada uma só passa uma lista diferente. mostrarValoresFinanceiros vem
// do pai (prop, não estado local): as duas abas compartilham a mesma instância de tabela por trás de cada
// v-tab-item, então se ficasse local ao componente, trocar de aba faria o botão "esquecer" o estado —
// igual à visão de diretoria, onde é uma variável só compartilhada entre todas as abas.
export default {
  name: 'CampanhaVendaMargemGerenteTabela',
  props: {
    lista: { type: Array, default: () => [] },
    mostrarValoresFinanceiros: { type: Boolean, default: false },
    // true só na aba "Acumulado Geral" — troca os rótulos das colunas de valor ("Meta" -> "Meta Acumulada"
    // etc.), deixando claro que ali é a soma da campanha inteira, não de um mês isolado
    acumulado: { type: Boolean, default: false },
  },
  computed: {
    labelMeta() {
      return this.acumulado ? 'Meta Acumulada' : 'Meta';
    },
    labelVenda() {
      return this.acumulado ? 'Venda Acumulada' : 'Venda';
    },
    labelAtingimento() {
      return this.acumulado ? 'Atingimento Acumulado' : '% Atingimento';
    },
    labelMargem() {
      return this.acumulado ? 'Margem Acumulada' : 'Margem';
    },
    linhas() {
      return [...this.lista].sort((a, b) => (b.total_cupons || 0) - (a.total_cupons || 0));
    },
    totais() {
      return this.linhas.reduce((acc, item) => {
        acc.cuponsRegra1 += item.cupons_regra1 || 0;
        acc.cuponsExtras += this.cuponsExtras(item);
        acc.totalCupons += item.total_cupons || 0;
        return acc;
      }, { cuponsRegra1: 0, cuponsExtras: 0, totalCupons: 0 });
    },
  },
  methods: {
    cuponsExtras(item) {
      return (item.cupons_bloco_a || 0) + (item.cupons_bloco_b || 0) + (item.cupons_bloco_c || 0)
          + (item.cupons_bloco_d || 0) + (item.cupons_bloco_e || 0) + (item.cupons_bloco_f || 0);
    },
    cuponsExtrasBlocos(item) {
      const blocos = [];
      if (item.cupons_bloco_a) blocos.push(`Bloco A (maior venda da rede): ${item.cupons_bloco_a}`);
      if (item.cupons_bloco_b) blocos.push(`Bloco B (maior venda da filial): ${item.cupons_bloco_b}`);
      if (item.cupons_bloco_c) blocos.push(`Bloco C (top 10 Educa e-book): ${item.cupons_bloco_c}`);
      if (item.cupons_bloco_d) blocos.push(`Bloco D (produto sem giro): ${item.cupons_bloco_d}`);
      if (item.cupons_bloco_e) blocos.push(`Bloco E (margem + atingimento individual): ${item.cupons_bloco_e}`);
      if (item.cupons_bloco_f) blocos.push(`Bloco F (meta trimestral): ${item.cupons_bloco_f}`);
      return blocos.length ? blocos : ['Sem cupons extras'];
    },
  },
};
</script>

<style scoped>
/* sublinhado pontilhado + cursor de ajuda: sinaliza que o número tem um detalhe por trás (o tooltip com a
   quebra por bloco), sem precisar passar o mouse pra descobrir */
.cupons-extras-com-detalhe {
  cursor: help;
  border-bottom: 1px dashed currentColor;
}
</style>
